module.exports = __webpack_public_path__ + "img/zahar.29a24485.jpg";